<div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column base-div"
     *ngIf="paymentModelInformation?.paymentMethod?.length === 0 || !paymentModelInformation || !paymentModelInformation?.paymentMethod">
  <div class="col-12 d-flex title-div">
    <div class="col-8 px-2">
      <label
        class="title">{{this.textService.keyValueMapping('paymentMethodSelectionHeader', 'Ödeme Yöntemi Seçin', user?.sdkInitTexts)}}</label>
    </div>
  </div>
  <div class="col-12 px-0 d-flex justify-content-center">
    <img class="no-card" [src]="'assets/images/png/no-card.png'" [srcset]="'assets/images/png/no-card@2x.png 2x, assets/images/png/no-card@3x.png 3x'" alt="logo">
  </div>
  <div class="col-12 px-0 d-flex justify-content-center"><label
    class="no-payment-method">{{this.textService.keyValueMapping('noPaymentMethodHeader', 'EKLİ ÖDEME YÖNTEMİNİZ YOK', user?.sdkInitTexts)}}</label>
  </div>
  <div class="col-12 px-0 d-flex justify-content-center"><label class="no-payment-method-description">
    {{this.textService.keyValueMapping('noPaymentMethodDescription', 'Kredi Kartı veya Paycell Kart ekleyerek buradan yönetebilir ve işlemlerinizde kullanabilirsiniz.', user?.sdkInitTexts)}}</label>
  </div>
  <div class="col-12 px-0 d-flex justify-content-center" *ngIf="showCardAddButton">
    <button class="button-style" (click)="addCardRouter()"><span
      class="text-style">{{this.textService.keyValueMapping('noPaymentMethodAddCardButton', 'Yeni Ekle', user?.sdkInitTexts)}}</span>
    </button>
  </div>
</div>

<div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column base-div"
     *ngIf="paymentModelInformation?.paymentMethod?.length > 0">
  <div class="col-12 d-flex title-div">
    <div class="col-8 px-2">
      <label
        class="title">{{this.textService.keyValueMapping('paymentMethodSelectionHeader', 'Ödeme Yöntemi Seçin', user?.sdkInitTexts)}}</label>
    </div>
    <div class="col-4 new-card-add-button-div px-0" *ngIf="showCardAddButton">
      <button class="button-style-new-card" (click)="addCardRouter()"><span class="show-image"><img class="add-image"
                                                                                                    [src]="'assets/images/png/add.png'"
                                                                                                    [srcset]="'assets/images/png/add@2x.png 2x, assets/images/png/add@3x.png 3x'"
                                                                                                    alt="logo"/></span><span
        class="text-style">{{this.textService.keyValueMapping('addCardButton', 'Yeni Kart Ekle', user?.sdkInitTexts)}}</span><span
        class="text-style-two">{{this.textService.keyValueMapping('mobileAddCardButton', 'Kart Ekle', user?.sdkInitTexts)}}</span>
      </button>
    </div>
  </div>
  <div class="col-12 d-flex justify-content-center carousel-div"
       [ngClass]="{'first':carousel.activeId=='ngb-slide-0','last':carousel.activeId=='ngb-slide-'+ (paymentModelInformation.paymentMethod.length -1)}">
    <ngb-carousel #carousel (slide)="findCarouselIndex($event)" [interval]="0" [wrap]="false"
                  [showNavigationArrows]="paymentModelInformation?.paymentMethod?.length > 1">
      <ng-template ngbSlide *ngFor="let card of paymentModelInformation.paymentMethod; let i = index"
                   [id]="'ngb-slide-' + i">
        <div class="picsum-img-wrapper">
          <img class="img-style"
               [src]="card.images != null ? card.images[0].imageUrl : 'assets/images/credit-card-big.png'"
               alt="Random first slide">
        </div>
      </ng-template>
    </ngb-carousel>
  </div>
  <div class="col-12 flex-column card-information-div">
    <div class="col-12 px-0" *ngIf="paymentInformation?.isSingle == '1'">
      <label
        class="balance-title">{{this.textService.keyValueMapping('relatedCardLabel', 'Bağlı Paycell Kart', user?.sdkInitTexts)}}</label>
    </div>
    <div class="col-12 px-0" *ngIf="paymentInformation?.paymentMethodType==='DCB'">
      <label class="balance">{{this.textService.keyValueMapping('cardAliasLabel', 'Kart Adı:', user?.sdkInitTexts)}}
        <span
          class="text-style">{{this.textService.keyValueMapping('instantLimitLabel', 'Faturana Yansıt Limitim', user?.sdkInitTexts)}}</span></label>
    </div>
    <div class="col-12 px-0" *ngIf="paymentInformation?.paymentMethodType!=='DCB'">
      <label class="balance">{{this.textService.keyValueMapping('cardAliasLabel', 'Kart Adı:', user?.sdkInitTexts)}}
        <span
          class="text-style">{{paymentInformation?.alias}}</span></label>
    </div>

    <div class="col-12 px-0" *ngIf="paymentInformation?.paymentMethodType!=='DCB'">
      <label
        class="balance">{{this.textService.keyValueMapping('cardNumberLabel', 'Kart numarası:', user?.sdkInitTexts)}}
        <span
          class="text-style">{{paymentInformation?.paymentMethodNumber}}</span></label>
    </div>

    <div class="col-12 px-0" *ngIf="paymentInformation?.paymentMethodType!='DCB'">
      <label class="balance"
             *ngIf="paymentInformation?.remainingLimit != null">{{this.textService.keyValueMapping('balanceLabel', 'Bakiye:', user?.sdkInitTexts)}}
        <span
          class="text-style">₺{{paymentInformation?.remainingLimit}}</span></label>
    </div>
    <div class="col-12 px-0" *ngIf="paymentInformation?.paymentMethodType=='DCB'">
      <label class="balance">{{this.textService.keyValueMapping('balanceLabel', 'Bakiye:', user?.sdkInitTexts)}} <span
        class="text-style">₺{{paymentInformation?.remainingLimit}}</span></label>
    </div>
    <div class="col-12 px-0" *ngIf="this.checkEMoney(paymentInformation) > 0">
      <label class="balance">{{this.textService.keyValueMapping('emoneyLabel', 'Hediye Para:', user?.sdkInitTexts)}}
        <span
          class="text-style">₺{{this.checkEMoney(paymentInformation) / 100 | amount}}</span></label>
    </div>
    <div class="col-12 px-0 d-flex"
         *ngIf="paymentInformation?.paymentMethodType=='DCB' && paymentInformation?.premiumText !== null">
      <img class="info" [src]="'assets/images/info.png'" [srcset]="'assets/images/info@2x.png 2x, assets/images/info@3x.png 3x'" alt="logo"/>
      <label class="limit-transfer">{{paymentInformation?.premiumText}}</label>
    </div>
    <form class="form-style" [formGroup]="paymentMethodSelectionForm" method="POST" autocomplete="off">
      <div class="col-lg-8 col-md-8 col-12 px-0" *ngIf="paymentInformation?.paymentMethodType==='CREDIT_CARD'">
        <mat-form-field class="input-style" *ngIf="showCvv">
          <mat-label>{{this.textService.keyValueMapping('cvvLabel', 'CVV kodu girin', user?.sdkInitTexts)}}</mat-label>
          <input id="cvvInput" type="password" pattern="[0-9]*" inputmode="numeric" maxlength="3" formControlName="cvv"
                 (ngModelChange)="changeEvent($event)" matInput tbOnlyNumber>
          <mat-icon class="cvv-info-tooltip" svgIcon="info" tooltipClass="web-tooltip"
                    [ngbTooltip]="cvvInfoTooltip" triggers="manual" placement="right" #tooltip="ngbTooltip"
                    (click)="tooltip.open()"
                    matSuffix>info
          </mat-icon>
          <mat-icon class="cvv-info-popup" svgIcon="info" (click)="createCvvModal()" matSuffix>info</mat-icon>
          <mat-error
            *ngIf="paymentMethodSelectionForm.controls.cvv.errors && paymentMethodSelectionForm.controls.cvv.errors.required">
            {{this.textService.keyValueMapping('msgPaymentCvv', 'Lütfen Kartınızın Arka Tarafında Yazan Cvv\'yi Giriniz.', user?.sdkInitTexts)}}
          </mat-error>
          <mat-error
            *ngIf="paymentMethodSelectionForm.controls.cvv.errors && paymentMethodSelectionForm.controls.cvv.errors.minlength">
            {{this.textService.keyValueMapping('msgPaymentCvvRule', 'Cvv 3 karakter olmalıdır.', user?.sdkInitTexts)}}
          </mat-error>
          <ng-template #cvvInfoTooltip>
            <div class="col-12 px-0">
              <img class="close-logo" [src]="'assets/images/whatispaycellclose.png'" [srcset]="'assets/images/whatispaycellclose@2x.png 2x, assets/images/whatispaycellclose@3x.png 3x'" (click)="tooltip.close()"
                   alt="logo"/>
            </div>
            <div class="col-12 px-0 d-flex justify-content-center">
              <img class="cvv-logo" [src]="'assets/images/png/card-cvv.png'" [srcset]="'assets/images/png/card-cvv@2x.png 2x,assets/images/png/card-cvv@3x.png 3x'" alt="logo"/>
            </div>
            <div class="col-12 px-0 d-flex justify-content-center">
    <span class="cvv-info-text">
      {{this.textService.keyValueMapping('cvvTooltipDescription', 'CVV, kartın arka yüzünde bulunan 3 haneli koddur.', user?.sdkInitTexts)}}</span>
            </div>
          </ng-template>
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
